import { observable, reaction, action } from 'mobx'
import {
  getFaultEquipmentByGroupFetchHandler,
  getCanInfoFetchHandler,
  getCanTypeNumFetchHandler,
} from '../utils/fetchData'
import GlobalControlStore from './GlobalControlStore'
class EquipmentViewStore {
  @observable choseType = 'all' //默认为总计
  @observable choseState = false
  @observable solutionType = null
  @observable solutionTime = null
  @observable isDelete = true
  @observable maxCount = null
  @observable choseDetailId = null
  @observable equipmentNeedUpdate = false
  @observable equipmentInfoMap = new Map()
  @observable currentPage = 1
  @observable size = 7
  @observable pageCount = 10
  @observable CustomizedFlag = false
  @observable choseCanName = null
  @observable choseCanInfo = null
  @observable choseCanNeedUpdate = false
  @observable searchShow = false
  //单个桶信息的错误分页
  @observable canCurrentPage = 1
  @observable canSize = 2
  @observable canTotalCount = 0
  @observable canPageCount = 1
  //各种桶类型数量
  @observable communicationTrouble = 0 //通信困难
  @observable noCommunication = 0 //无法交流
  @observable rangingTrouble = 0 //测距困难
  @observable rangingException = 0 //测不准
  @observable otherReason = 0 //其他原因
  @observable repairCansCount = 0 //统计
  @observable resolved = 0 //已经解决的个数
}

const store = new EquipmentViewStore()

const equipmentUpdateReaction = reaction(
  () => store.equipmentNeedUpdate,
  (flag, reaction) => {
    if (flag) {
      getFaultEquipmentByGroupFetchHandler(
        store.currentPage,
        store.size,
        store.choseType,
        (data) => {
          store.maxCount = data.maxCount
          store.pageCount = Math.ceil(data.maxCount / store.size)
          store.equipmentInfoMap.clear()
          for (let can of data.resultCans) {
            if (!can.repairs) continue
            store.equipmentInfoMap.set(can._id, can)
          }
        },
        () => {},
        () => {
          GlobalControlStore.showLoading = false
        }
      )
      getCanTypeNumFetchHandler(
        (res) => {
          store.communicationTrouble = res.communication_trouble
          store.noCommunication = res.no_communication
          store.rangingTrouble = res.ranging_trouble
          store.rangingException = res.ranging_exception
          store.otherReason = res.other_reason
          store.repairCansCount = res.all
          store.resolved = res.resolved
        },
        (err) => {}
      )
      store.equipmentNeedUpdate = false
    }
  }
)
const choseCanUpdateReaction = reaction(
  () => store.choseCanNeedUpdate,
  (flag, reaction) => {
    if (flag) {
      if (!store.choseDetailId) {
        store.choseCanNeedUpdate = false
        return
      }
      GlobalControlStore.showLoading = true
      getCanInfoFetchHandler(
        store.choseDetailId,
        store.canCurrentPage,
        store.canSize,
        (res) => {
          store.canPageCount = Math.ceil(res.meta.max / store.canSize)
          store.canTotalCount = res.meta.max
          store.choseCanInfo = res.repairs
          store.choseState = res.clear
          store.choseCanNeedUpdate = false
        },
        (err) => {},
        () => {
          GlobalControlStore.showLoading = false
        }
      )
    }
    store.choseCanNeedUpdate = false
  }
)
reaction(
  //监测点击了哪种类型的设备
  () => store.choseType,
  (type, reaction) => {
    GlobalControlStore.showLoading = true
    store.choseDetailId = null
    store.currentPage = 1
    getFaultEquipmentByGroupFetchHandler(
      1,
      store.size,
      type,
      (data) => {
        store.maxCount = data.maxCount
        store.pageCount = Math.ceil(data.maxCount / store.size)
        store.equipmentInfoMap.clear()
        for (let can of data.resultCans) {
          if (!can.repairs) continue
          store.equipmentInfoMap.set(can._id, can)
        }
      },
      () => {},
      () => {
        GlobalControlStore.showLoading = false
      }
    )
  }
)
export default store



// WEBPACK FOOTER //
// ./src/store/EquipmentViewStore.js